import { LANGUAGECODE } from '../enums/LANGUAGECODE.js';
/** A 'Translate' Event replaces text based on the selected language */
export default class Translate extends CustomEvent {
    constructor(caller, language) {
        super('translate', {
            bubbles: false,
            detail: {
                caller,
                language
            }
        });
    }
}
export { LANGUAGECODE };
